import {http} from '@/helpers/http-helper';

export const getQueryCategories = () => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createQueryCategory = (queryCategory) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories';
        http.post(url, queryCategory)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateQueryCategory = (uuid, queryCategory) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories/' + uuid;
        http.post(url, queryCategory)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryCategory = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories/' + uuid;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteQueryCategory = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories/' + uuid;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getCategoriesRecursive = (categoriesTree, level, parent) => {
    let depth = level || 0;
    let categories = [];
    categoriesTree.forEach((category) => {
        let categoryParent = parent || category.uuid;
        category.parent = categoryParent;
        category.depth = depth;
        categories.push(category);
        if (Array.isArray(category.children) && category.children.length) {
            categories = categories.concat(getCategoriesRecursive(category.children, depth+1, categoryParent));
        }
    });

    return categories;
};

export const getQueryCategoriesTree = () => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories/tree';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(getCategoriesRecursive(response.data));
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryCategoriesTreeSimple = () => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/categories/tree';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};